import Box from "@mui/material/Box";
import { TreeView } from "../components/TreeView/Treeview";
import { useNavigate, useParams } from "react-router-dom";
import { CategoryPlaceholder } from "./CategoryPlaceholder";
import { CategoryContent } from "./CategoryContent";
import useProductCategory from "./hooks/useProductCategory";
import {
  getCategoryLeafDescendantIds,
  getProductCategoriesTree,
  sortProductCategories,
} from "./utils";
import { useMemo } from "react";

export const CategoryPage = () => {
  const navigate = useNavigate();

  const { categoryId } = useParams<{ categoryId: string }>();

  const { productCategoryData, loading, productCategoryMap } =
    useProductCategory();

  const sortedProductCategories = sortProductCategories(productCategoryData);

  const parentCategories = sortedProductCategories.filter(
    (category) => category.parentId === "0"
  );

  const productCategoryItems = getProductCategoriesTree(
    parentCategories,
    sortedProductCategories
  );

  const categoryLeafDescendantIds = useMemo(() => {
    if (!categoryId || !productCategoryMap[categoryId]) {
      return [];
    }

    return getCategoryLeafDescendantIds(
      productCategoryMap[categoryId],
      productCategoryData
    );
  }, [categoryId, productCategoryData, productCategoryMap]);

  return (
    <Box display="flex" gap={1} height="100%">
      <Box width={370} sx={{ overflowY: "auto" }}>
        <TreeView
          id="product-category-tree"
          inputText="Search for Product Category"
          isLoading={loading}
          items={productCategoryItems}
          onClick={({ id }) => {
            navigate(`/catalog/product/category/${id}`);
          }}
        />
      </Box>

      <Box width="1px" bgcolor="divider" height="100%" />

      <Box flex={1} sx={{ overflowY: "auto" }}>
        {categoryId ? (
          <CategoryContent
            leafCategoryIds={categoryLeafDescendantIds}
            categoryName={productCategoryMap[categoryId]?.name}
          />
        ) : (
          <CategoryPlaceholder />
        )}
      </Box>
    </Box>
  );
};
